import React, { useEffect, useState } from 'react'
import { PageSection } from 'components/layout'
import Logger from 'services/Logger'
import styled from '@emotion/styled'
import { JerryLogo } from 'components/patterns/icons'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'
import Spinner from 'components/elements/Spinner'
import { useRouter } from 'next/router'
import { CampaignIDs } from 'types/index'
import SimpleHeader from 'components/layout/SimpleHeader'
import { getImpressionsClient } from 'services/FionaAPI/clients'
import { ImpressionWithId } from 'generated/api'

const jerry = 'https://getjerry.com/signup?utm_source=pfiona'

const AutoInsuranceRedirect = (): JSX.Element => {
	const [counter, setCounter] = useState(2)
	const [impressionId, setImpressionId] = useState<string | undefined>(undefined)

	const router = useRouter()

	async function getImpressionId(): Promise<void> {
		const impressionClient = getImpressionsClient()
		const toSend = {
			impressionRequest: { campaign: CampaignIDs.JERRY }
		}
		impressionClient
			.createImpression(toSend)
			.then((response: ImpressionWithId) => {
				setImpressionId(response.id)
			})
			.catch(Logger.error)
	}

	useEffect(() => {
		const timer = setInterval(() => setCounter(counter - 1), 1000)
		if (counter < 1) {
			clearInterval(timer)
			if (impressionId) {
				const urlWithId = `${jerry}&clickID=${impressionId}`
				router.push(urlWithId).catch(Logger.error)
			} else {
				router.push(jerry).catch(Logger.error)
			}
		}
		return (): void => clearInterval(timer)
	}, [counter, impressionId, router])

	useEffect(() => {
		getImpressionId()
	}, [])

	return (
		<PageSection>
			<SimpleHeader />
			<Wrapper>
				<Title>Redirecting to...</Title>
				<JerryLogo />
				<Spinner />
			</Wrapper>
		</PageSection>
	)
}

export default AutoInsuranceRedirect

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 775px;
	align-items: center;
	margin: 0 auto;
	background-color: ${COLORS.WHITE};
	padding: 44px;
	border-radius: 4px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	border: solid 1px #e3e3e3;
	margin-top: 180px;
	img {
		width: 200px;
	}
	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		width: 90%;
		margin-top: 90px;
	}
`

const Title = styled.h2`
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 30px;
`
